const dimensions = {
  rem: (value) =>
    value * parseFloat(getComputedStyle(document.documentElement).fontSize),
  vh: (value) =>
    (value * parseFloat(getComputedStyle(document.documentElement).height)) /
    100,
  vw: (value) =>
    (value * parseFloat(getComputedStyle(document.documentElement).width)) /
    100,
  dh: (value) => (value * parseFloat(window.screen.availHeight)) / 100,
  dw: (value) => (value * parseFloat(window.screen.availWidth)) / 100,
}

export default dimensions
